module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQFJREFUWEftlU1KA0EQhb93nSSQVe7iLhgwSDxPRPxbuPA0AUEMHueFWQyMbUx3Y09qk9oOVfX1q6o3IjgU3J8LQJUCth8k3bYcWxGA7TnwBCwkFeWUQmaL2b4GXvuCZwWwvQU2w9ecBcD2BHgHOulbxl7S7MeD0uq2V8BLy66nFPy1A+EAHW3oCIZyhS1hAhF3hj1IqBElasRYcc1J2n6UtC7NyVpxaaHBuAx8AGtJu1z+WAB93ztJ96cgxgboer9JWv4FccwJv4BpTrrK79/AlaTPNO8YQDfDseJG0nPuZxQOEDuC/2pvO1WwbgkbA4SdYagRxVpx7QibO+EFoFaBAyOocCEX6NIBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/navBtn2.png
// module id = Nxmr
// module chunks = 1